import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
const width = {
    /** 長さ指定をしない流動的なコンテンツ用 */
    lg: 'w-[300px]',
    md: 'w-[200px]',
    sm: 'w-[100px]',
    fluid: '', // eslint-disable-line sort-keys-fix/sort-keys-fix
};
const height = {
    /** 長さ指定をしない流動的なコンテンツ用 */
    lg: 'h-[48px]',
    md: 'h-[40px]',
    sm: 'h-[30px]',
    fluid: '', // eslint-disable-line sort-keys-fix/sort-keys-fix
};
const textSizes = {
    fluid: 'none',
    lg: 'md',
    md: 'sm',
    sm: 'xs',
};
const spaces = {
    lg: 'py-12 px-8',
    md: 'py-8 px-8',
    sm: 'py-4 px-8',
    fluid: '', // eslint-disable-line sort-keys-fix/sort-keys-fix
};
/**
 * <button>のラッパーコンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @constructor
 */
export const ButtonBase = (props) => {
    const { children, className = '', disabled = false, isBordered = true, isFull = false, isFullRounded = false, onClick = () => { }, size, textClassName = '', textColor, type = 'button', value, } = props;
    /* eslint-disable react/button-has-type */
    return (_jsx("button", Object.assign({ className: clsx('inline-flex items-center justify-center', isBordered && 'border border-solid', isFullRounded ? 'rounded-full' : 'rounded-md', isFull ? 'w-full' : width[size], height[size], spaces[size], 'hover:cursor-pointer', 'hover:no-underline', className), disabled: disabled, onClick: onClick, type: type, value: value }, { children: _jsx(Text, Object.assign({ className: textClassName, color: textColor, size: textSizes[size], tagName: 'span' }, { children: children })) })));
};
export const buttonBaseSpaces = spaces;
export const buttonBaseTextSizes = textSizes;
export const buttonBaseWidth = width;
export const buttonBaseHeight = height;
